var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "page",
      staticClass: "page",
      attrs: {
        "element-loading-text": "加载中...",
        "element-loading-background": "rgba(0, 0, 0, 0.3)",
      },
    },
    [
      _c("div", { ref: "search", staticClass: "page-search" }, [
        _c(
          "div",
          { staticClass: "search-row" },
          [
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "开始日期",
                "value-format": "yyyy-MM-dd",
                "picker-options": _vm.startDatePickerOptions,
              },
              model: {
                value: _vm.searchForm.startTime,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "startTime", $$v)
                },
                expression: "searchForm.startTime",
              },
            }),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "结束日期",
                "value-format": "yyyy-MM-dd",
                "picker-options": _vm.endDatePickerOptions,
              },
              model: {
                value: _vm.searchForm.endTime,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "endTime", $$v)
                },
                expression: "searchForm.endTime",
              },
            }),
            _c("el-input", {
              attrs: { placeholder: "请输入客户编码" },
              model: {
                value: _vm.searchForm.customerCode,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "customerCode", $$v)
                },
                expression: "searchForm.customerCode",
              },
            }),
            _c("el-input", {
              attrs: { placeholder: "请输入客户名称" },
              model: {
                value: _vm.searchForm.customerName,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "customerName", $$v)
                },
                expression: "searchForm.customerName",
              },
            }),
            _c("el-input", {
              staticStyle: { "margin-right": "0" },
              attrs: { placeholder: "请输入分公司编码" },
              model: {
                value: _vm.searchForm.subCompanyCode,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "subCompanyCode", $$v)
                },
                expression: "searchForm.subCompanyCode",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-row" },
          [
            _c("el-input", {
              attrs: { placeholder: "请输入分公司名称" },
              model: {
                value: _vm.searchForm.subCompanyName,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "subCompanyName", $$v)
                },
                expression: "searchForm.subCompanyName",
              },
            }),
            _c("el-input", {
              attrs: { placeholder: "请输入产品名称" },
              model: {
                value: _vm.searchForm.productName,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "productName", $$v)
                },
                expression: "searchForm.productName",
              },
            }),
            _c("el-input", {
              attrs: { placeholder: "请输入产品编码" },
              model: {
                value: _vm.searchForm.productCode,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "productCode", $$v)
                },
                expression: "searchForm.productCode",
              },
            }),
            _c("el-input", {
              attrs: { placeholder: "请输入公司主体" },
              model: {
                value: _vm.searchForm.companyName,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "companyName", $$v)
                },
                expression: "searchForm.companyName",
              },
            }),
            _c(
              "el-select",
              {
                staticStyle: { "margin-right": "0" },
                attrs: { placeholder: "请选择渠道模式" },
                model: {
                  value: _vm.searchForm.saleChannel,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "saleChannel", $$v)
                  },
                  expression: "searchForm.saleChannel",
                },
              },
              _vm._l(_vm.channelOptions, function (item) {
                return _c("el-option", {
                  key: item.dictCode,
                  attrs: { label: item.dictValue, value: item.dictCode },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-row" },
          [
            _c("el-input", {
              attrs: { placeholder: "请输入需货单号" },
              model: {
                value: _vm.searchForm.orderCode,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "orderCode", $$v)
                },
                expression: "searchForm.orderCode",
              },
            }),
            _c("el-input", {
              attrs: { placeholder: "请输入产品系列" },
              model: {
                value: _vm.searchForm.productLevelName,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "productLevelName", $$v)
                },
                expression: "searchForm.productLevelName",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "select-row",
            staticStyle: { "justify-content": "space-between" },
          },
          [
            _c(
              "div",
              [
                _c(
                  "span",
                  {
                    staticStyle: { "font-weight": "bold", "font-size": "14px" },
                  },
                  [_vm._v("动态模块展示选择：")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "default" },
                    on: { click: _vm.openModuleDialog },
                  },
                  [_vm._v("选择模块")]
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "14px",
                      "margin-left": "20px",
                    },
                  },
                  [_vm._v("动态二级参数选择：")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "default" },
                    on: { click: _vm.openParamDialog },
                  },
                  [_vm._v("选择参数")]
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "14px",
                      "margin-left": "20px",
                    },
                  },
                  [_vm._v("动态三级参数选择：")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "default" },
                    on: { click: _vm.openThirdLevelDialog },
                  },
                  [_vm._v("选择参数")]
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSearch },
                  },
                  [_vm._v("查询")]
                ),
                _c("el-button", { on: { click: _vm.handleReset } }, [
                  _vm._v("重置"),
                ]),
                _c("el-button", { on: { click: _vm.handleExport } }, [
                  _vm._v("导出"),
                ]),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "page-table" },
        [
          _c(
            "vxe-table",
            {
              key: _vm.tableKey,
              ref: "xTable",
              attrs: {
                border: "",
                "show-overflow": "",
                size: "mini",
                resizable: "",
                data: _vm.tableData,
                "auto-resize": true,
                "fixed-header": true,
                height: _vm.tableHeight,
                "show-footer": true,
                "footer-method": _vm.footerMethod,
              },
            },
            [
              _c("vxe-column", {
                attrs: { field: "yearMonthStr", width: "100", title: "期间" },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "invoiceDate",
                  width: "100",
                  title: "业务日期",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "subCompanyName",
                  width: "100",
                  title: "分公司",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "customerName", width: "100", title: "经销商" },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "productCode",
                  width: "100",
                  title: "产品编码",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "productName",
                  width: "100",
                  title: "产品名称",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "spec", width: "100", title: "规格型号" },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "actualTaxPrice",
                  width: "120",
                  title: "实际含税单价(元/盒)",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "totalQuantity",
                  width: "100",
                  title: "数量(盒)",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "totalAmount",
                  width: "120",
                  title: "应收金额(含税)",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "companyName",
                  width: "100",
                  title: "公司主体",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "saleChannelName",
                  width: "100",
                  title: "渠道模式",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "orderCode", width: "100", title: "需货单号" },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "productLevelName",
                  width: "100",
                  title: "产品系列",
                },
              }),
              _vm.showModule("group1")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "生产投入",
                        field: "group1",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showParam("dealerInput")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "经销商投入",
                                field: "group1-1",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("scanFee")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "扫码费用",
                                        field: "group1-1-1",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scJxsScanFeeStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scJxsScanFeeAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("quarterAchieve")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "季度达成",
                                        field: "group1-1-2",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scJxsQuarterAchieveStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scJxsQuarterAchieveAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("stablePriceSubsidy")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "稳价补贴",
                                        field: "group1-1-3",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scJxsStablePriceSubsidyStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scJxsStablePriceSubsidyAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("tobaccoShopInput")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "烟酒店投入",
                                field: "group1-2",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("scanFee")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "扫码费用",
                                        field: "group1-2-1",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scYjdScanFeeStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scYjdScanFeeAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("quarterAchieve")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "季度达成",
                                        field: "group1-2-2",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scYjdQuarterAchieveStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scYjdQuarterAchieveAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("reverseSales")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "动销反向",
                                        field: "group1-2-3",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scYjdReverseSalesStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scYjdReverseSalesAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("stablePriceSubsidy")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "稳价补贴",
                                        field: "group1-2-4",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scYjdStablePriceSubsidyStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scYjdStablePriceSubsidyAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("marketOperationInput")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "市场运营投入",
                                field: "group1-3",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("strategyInput")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "战略投入",
                                        field: "group1-3-1",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scScyyStrategyInputStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scScyyStrategyInputAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("companyOverallInput")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "公司统筹投入",
                                        field: "group1-3-2",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scScyyCompanyOverallInputStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scScyyCompanyOverallInputAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("marketBaseOverall")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "市场基础投入-统筹",
                                        field: "group1-3-3",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scScyyMarketBaseOverallStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scScyyMarketBaseOverallAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("marketBaseCustomer")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "市场基础投入-经销商",
                                        field: "group1-3-4",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scScyyMarketBaseCustomerStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scScyyMarketBaseCustomerAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("specialInput")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "专项投入",
                                        field: "group1-3-5",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scScyySpecialInputStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scScyySpecialInputAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("salesCommission")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "销售人员提成",
                                field: "group1-4",
                                "header-align": "center",
                              },
                            },
                            [
                              _c("vxe-column", {
                                attrs: {
                                  field: "scSalesCommissionStandard",
                                  width: "100",
                                  title: "标准",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  field: "scSalesCommissionAmount",
                                  width: "100",
                                  title: "金额",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("promoterRights")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "推广大使权益",
                                field: "group1-5",
                                "header-align": "center",
                              },
                            },
                            [
                              _c("vxe-column", {
                                attrs: {
                                  field: "scAmbassadorRightsStandard",
                                  width: "100",
                                  title: "标准",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  field: "scAmbassadorRightsAmount",
                                  width: "100",
                                  title: "金额",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("fengxiangHui")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "凤香荟",
                                field: "group1-6",
                                "header-align": "center",
                              },
                            },
                            [
                              _c("vxe-column", {
                                attrs: {
                                  field: "scFxhStandard",
                                  width: "100",
                                  title: "标准",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  field: "scFxhAmount",
                                  width: "100",
                                  title: "金额",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("consumerReward")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "消费者奖励",
                                field: "group1-7",
                                "header-align": "center",
                              },
                            },
                            [
                              _c("vxe-column", {
                                attrs: {
                                  field: "scConsumerRewardStandard",
                                  width: "100",
                                  title: "标准",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  field: "scConsumerRewardAmount",
                                  width: "100",
                                  title: "金额",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("channelCost")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "渠道费用",
                                field: "group1-8",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("jointBuildFee")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "厂商共建费用",
                                        field: "group1-8-1",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scQdJointBuildFeeStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scQdJointBuildFeeAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("discountFee")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "折让费用",
                                        field: "group1-8-2",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scQdDiscountFeeStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scQdDiscountFeeAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("outboundScanReward")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "出库扫码奖励",
                                        field: "group1-8-3",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scQdOutboundScanRewardStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scQdOutboundScanRewardAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("deposit")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "保证金",
                                        field: "group1-8-4",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scQdDepositStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scQdDepositAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showThirdLevel("salesRelatedReward")
                                ? _c(
                                    "vxe-colgroup",
                                    {
                                      attrs: {
                                        title: "动销关联奖励",
                                        field: "group1-8-5",
                                        "header-align": "center",
                                      },
                                    },
                                    [
                                      _c("vxe-column", {
                                        attrs: {
                                          field:
                                            "scQdSalesRelatedRewardStandard",
                                          width: "100",
                                          title: "标准",
                                        },
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          field: "scQdSalesRelatedRewardAmount",
                                          width: "100",
                                          title: "金额",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "scSubtotal",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group2")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "释放投入",
                        field: "group2",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showParam("dealerInput")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "经销商投入",
                                field: "group2-1",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("scanFee")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfJxsScanFee",
                                      width: "100",
                                      title: "扫码费用",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("quarterAchieve")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfJxsQuarterAchieveAmount",
                                      width: "100",
                                      title: "季度达成",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("stablePriceSubsidy")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfJxsStablePriceSubsidyAmount",
                                      width: "100",
                                      title: "稳价补贴",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("tobaccoShopInput")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "烟酒店投入",
                                field: "group2-2",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("scanFee")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfYjdScanFeeAmount",
                                      width: "100",
                                      title: "扫码费用",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("quarterAchieve")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfYjdQuarterAchieveAmount",
                                      width: "100",
                                      title: "季度达成",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("reverseSales")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfYjdReverseSalesAmount",
                                      width: "100",
                                      title: "动销反向",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("stablePriceSubsidy")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfYjdStablePriceSubsidyAmount",
                                      width: "100",
                                      title: "稳价补贴",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("marketOperationInput")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "市场运营投入",
                                field: "group2-3",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("strategyInput")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfScyyStrategyInputAmount",
                                      width: "100",
                                      title: "战略投入",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("companyOverallInput")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfScyyCompanyOverallInputAmount",
                                      width: "100",
                                      title: "公司统筹投入",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("marketBaseOverall")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfScyyMarketBaseOverallAmount",
                                      width: "100",
                                      title: "市场基础投入-统筹",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("marketBaseCustomer")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfScyyMarketBaseCustomerAmount",
                                      width: "100",
                                      title: "市场基础投入-经销商",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("specialInput")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfScyySpecialInputAmount",
                                      width: "100",
                                      title: "专项投入",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("salesCommission")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "sfSalesCommission",
                              width: "100",
                              title: "销售人员提成",
                            },
                          })
                        : _vm._e(),
                      _vm.showParam("promoterRights")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "sfAmbassadorRightsAmount",
                              width: "100",
                              title: "推广大使权益",
                            },
                          })
                        : _vm._e(),
                      _vm.showParam("fengxiangHui")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "sfFxhAmount",
                              width: "100",
                              title: "凤香荟",
                            },
                          })
                        : _vm._e(),
                      _vm.showParam("consumerReward")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "sfConsumerRewardAmount",
                              width: "100",
                              title: "消费者奖励",
                            },
                          })
                        : _vm._e(),
                      _vm.showParam("channelCost")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "渠道费用",
                                field: "group2-4",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("jointBuildFee")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfQdJointBuildFeeAmount",
                                      width: "100",
                                      title: "厂商共建费用",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("discountFee")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfQdDiscountFeeAmount",
                                      width: "100",
                                      title: "折让费用",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("outboundScanReward")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfQdOutboundScanRewardAmount",
                                      width: "100",
                                      title: "出库扫码奖励",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("deposit")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfQdDepositAmount",
                                      width: "100",
                                      title: "保证金",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("salesRelatedReward")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "sfQdSalesRelatedRewardAmount",
                                      width: "100",
                                      title: "动销关联奖励",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "sfSubtotal",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group3")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "已申请投入",
                        field: "group3",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showParam("dealerInput")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "经销商投入",
                                field: "group3-1",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("scanFee")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqJxsScanFee",
                                      width: "100",
                                      title: "扫码费用",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("quarterAchieve")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqJxsQuarterAchieveAmount",
                                      width: "100",
                                      title: "季度达成",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("stablePriceSubsidy")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqJxsStablePriceSubsidyAmount",
                                      width: "100",
                                      title: "稳价补贴",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("tobaccoShopInput")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "烟酒店投入",
                                field: "group3-2",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("scanFee")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqYjdScanFeeAmount",
                                      width: "100",
                                      title: "扫码费用",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("quarterAchieve")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqYjdQuarterAchieveAmount",
                                      width: "100",
                                      title: "季度达成",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("reverseSales")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqYjdReverseSalesAmount",
                                      width: "100",
                                      title: "动销反向",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("stablePriceSubsidy")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqYjdStablePriceSubsidyAmount",
                                      width: "100",
                                      title: "稳价补贴",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showParam("consumerReward")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "ysqConsumerRewardAmount",
                              width: "100",
                              title: "消费者奖励",
                            },
                          })
                        : _vm._e(),
                      _vm.showParam("channelCost")
                        ? _c(
                            "vxe-colgroup",
                            {
                              attrs: {
                                title: "渠道费用",
                                field: "group3-3",
                                "header-align": "center",
                              },
                            },
                            [
                              _vm.showThirdLevel("jointBuildFee") ||
                              _vm.showThirdLevel("discountFee")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqQdDiscountJointBuildFeeAmount",
                                      width: "100",
                                      title: "折让/厂商共建费用",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("outboundScanReward")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqQdOutboundScanRewardAmount",
                                      width: "100",
                                      title: "出库扫码奖励",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("deposit")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqQdDepositAmount",
                                      width: "100",
                                      title: "保证金",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showThirdLevel("salesRelatedReward")
                                ? _c("vxe-column", {
                                    attrs: {
                                      field: "ysqQdSalesRelatedRewardAmount",
                                      width: "100",
                                      title: "动销关联奖励",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "ysqSubtotal",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pagination.pageNum,
                  "page-sizes": [15, 20, 25],
                  "page-size": _vm.pagination.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pagination.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "动态模块展示选择",
            visible: _vm.showModuleDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showModuleDialog = $event
            },
            close: function ($event) {
              _vm.showModuleDialog = false
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.tempModuleChooseKey,
                callback: function ($$v) {
                  _vm.tempModuleChooseKey = $$v
                },
                expression: "tempModuleChooseKey",
              },
            },
            _vm._l(_vm.moduleOptions, function (item) {
              return _c(
                "el-checkbox",
                { key: item.value, attrs: { label: item.value } },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleModuleCancel } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleModuleConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "动态二级参数选择",
            visible: _vm.showParamDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showParamDialog = $event
            },
            close: function ($event) {
              _vm.showParamDialog = false
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.tempParamChooseKey,
                callback: function ($$v) {
                  _vm.tempParamChooseKey = $$v
                },
                expression: "tempParamChooseKey",
              },
            },
            _vm._l(_vm.paramOptions, function (item) {
              return _c(
                "el-checkbox",
                { key: item.value, attrs: { label: item.value } },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleParamCancel } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleParamConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "动态三级参数选择",
            visible: _vm.showThirdLevelDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showThirdLevelDialog = $event
            },
            close: function ($event) {
              _vm.showThirdLevelDialog = false
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.tempThirdLevelChooseKey,
                callback: function ($$v) {
                  _vm.tempThirdLevelChooseKey = $$v
                },
                expression: "tempThirdLevelChooseKey",
              },
            },
            _vm._l(_vm.thirdLevelOptions, function (item) {
              return _c(
                "el-checkbox",
                { key: item.value, attrs: { label: item.value } },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleThirdLevelCancel } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleThirdLevelConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }